import React, { useState } from 'react'
import AddFeedbackModal from 'theme/modals/add-feedback-modal'
import { useAuthService } from 'theme/services/auth/auth-service'

const initialFeedbackModalState = {
  isOpen: false,
  feedbackIds: null,
  sessionData: null,
  reloadFeedbackCallback: () => undefined,
}

// eslint-disable-next-line react/display-name
const withFeedbackModal = (WrappedComponent) => (props) => {
  const authService = useAuthService()
  const user = authService?.user
  const [feedbackModal, toggleFeedbackModal] = useState(initialFeedbackModalState)

  const openFeedbackModal = (
    feedbackIds = null,
    sessionData = null,
    conferenceId = null,
    isDbRead,
    reloadFeedbackCallback,
  ) => {
    if (!authService) {
      return
    }

    if (!user) {
      authService.openLoginModal()
      return
    }

    if (!isDbRead) {
      return
    }

    toggleFeedbackModal({
      isOpen: true,
      feedbackIds,
      sessionData,
      conferenceId,
      reloadFeedbackCallback,
    })
  }

  const closeFeedbackModal = () => {
    toggleFeedbackModal(initialFeedbackModalState)
  }

  return (
    <>
      <WrappedComponent {...props} openFeedbackModal={openFeedbackModal} />
      {feedbackModal.isOpen && (
        <AddFeedbackModal
          openModal={feedbackModal.isOpen}
          handleClose={() => closeFeedbackModal()}
          data={feedbackModal.feedbackIds}
          session={feedbackModal.sessionData}
          conferenceId={feedbackModal.conferenceId}
          reloadFeedbackCallback={feedbackModal.reloadFeedbackCallback}
        />
      )}
    </>
  )
}

export default withFeedbackModal
